<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Service Offerings</h2>

        <small class="text-muted">Manage all your Service Offerings. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Content
        </span>
      </base-button>
    </div>
    <BlogPartnershipTable />
  </b-card>
</template>

<script>
import BlogPartnershipTable from "./components/BlogPartnershipTable.vue";

export default {
  components: {
    BlogPartnershipTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addpartnershipblogcontent" });
    },
  },
};
</script>
